import { BaseMediaApiModel } from '@era/inroom-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { RadioChannelsActionsUnion, RadioChannelsActionTypes } from './radio-channels.actions';

export const inRoomRadioChannelsFeatureKey = 'inroom-radio-channels';

export type RadioChannelsState = EntityState<BaseMediaApiModel>;

export function selectRadioChannelId(radioChannel: BaseMediaApiModel): string {
  return radioChannel.Identifier ?? '';
}

export const adapter: EntityAdapter<BaseMediaApiModel> = createEntityAdapter<BaseMediaApiModel>({
  selectId: selectRadioChannelId,
});

export const initialState: RadioChannelsState = adapter.getInitialState({});

export function radioChannelReducer(
  state: RadioChannelsState = initialState,
  action: RadioChannelsActionsUnion
): RadioChannelsState {
  switch (action.type) {
    case RadioChannelsActionTypes.LOAD_RADIO_CHANNELS:
      return adapter.setAll(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectRadioChannelIds = selectIds;

export const selectRadioChannelEntities = selectEntities;

export const selectAllRadioChannels = selectAll;

export const selectRadioChannelsTotal = selectTotal;
